import React from 'react';
import clsx from 'clsx';


const TextElement = ({
  arr,
  text,
  tool,
  isSelected,
  color,
  element,
  index,
  handleTextResizeStart,
  handleElementMoveStart
}) => {
  const textColor = color && isSelected ? color : element.color;
  const textFont = text.fontFamily && isSelected ? text.fontFamily : element.font;

  return (
    <div
      key={`w-${index}`}
      className={isSelected ? 'layerIsSelected' : ''}
      onMouseDown={handleElementMoveStart}
      style={{
        zIndex: arr.length*10 - index*10,
        position: 'absolute',
        left: element.coordinates.x,
        top: element.coordinates.y,
        display: element.hidden ? 'none' : '',
        color: textColor,
        fontSize: element.size + 'px',
        margin: 0, padding: 0,
        height: 'fit-content',
      }}>
      <div
        className={clsx({
          'leftExpand': tool == 'resize'
        })}
        onMouseDown={handleTextResizeStart}>
      </div>
      <div
        id={element.name}
        style={{ height: '100%', width: element.width + 'px', fontSize: element.size, lineHeight: 1, position: 'relative', zIndex: arr.length*10 - index*10, color: textColor, fontFamily: textFont }}
        className={clsx({
          'text-wrapper': true,
          'move': tool == 'move' && true
        })}>
        {element.text}
      </div>
      <div
        className={clsx({
          'rightExpand': tool == 'resize',
        })}
        onMouseDown={handleTextResizeStart}>
      </div>
    </div>
  );
};


export default TextElement;